import React, { useState } from 'react';

import { ArtistInvite as ArtistInvitePage, Claim as ClaimPage } from './page/Claim.jsx';
import InvoiceConfirmation from './page/InvoiceConfirmation.jsx';
import { Onboarding as OnboardingPage } from './page/Onboarding.jsx';
import { OnboardingMantineRoot } from './onboarding/OnboardingMantineRoot.tsx';
import { OnboardingV2 } from './onboarding/v2/OnboardingV2.tsx';
import { Inventory, User } from './common/repository/Type.jsx';
import PasswordReset from './page/PasswordReset.jsx';


const ArtistInvite = (props) => (
    <OnboardingMantineRoot>
        <ArtistInvitePage {...props} />
    </OnboardingMantineRoot>
);

const Claim = (props) => (
    <OnboardingMantineRoot>
        <ClaimPage {...props} />
    </OnboardingMantineRoot>
);

// ACA-266 §3.7: the flip. The v2 wizard carries no Mantine dependency of its own (§4.4), so the
// provider wraps only the legacy arm - which, as of ACA-269 Phase 4, no longer includes any picker
// choice: all four personas (Gallery, Artist, Collector, Jewelry) render inside OnboardingV2 now.
// onPersonaOutsideV2 below is kept regardless (D6, OnboardingV2.tsx's own doc comment on the prop
// explains why) - it just has no live caller left inside that component to fire it.
//
// isArtistReferral (out of scope, §7.3) skips the picker in the legacy arm too - the mount effect
// there checks it before anything else. v2 has no such check, so without excluding it here a
// referral link would land on the picker for an extra click instead of going straight to
// ArtistRegister. ACA-267 Phase 5 gave v2 its own Artist branch, but that is a *fresh* pick from
// the picker - a referral link is a different thing (an existing invitation) and stays routed to
// the legacy arm exactly as before.
const Onboarding = (props) => {
    const [legacyInitialType, setLegacyInitialType] = useState(undefined);
    // A second, deliberately separate reason to fall through to the legacy arm: a session ghost
    // whose Type turned out not to be Gallery. It must NOT set legacyInitialType - that prop
    // routes the legacy arm's mount effect through a fresh, unauthenticated registration step,
    // which mints a second account over the one the session already names. (Step.ArtistRegister was
    // the original example here; ACA-268 brought Collector inside v2 and ACA-269 brought Jewelry -
    // the last persona that could ever land here - so legacyInitialType now has no live setter
    // inside a real OnboardingV2: setLegacyInitialType is still wired to onPersonaOutsideV2 below,
    // same as before, but nothing in that component calls it any more. Left in place rather than
    // removed, for the same reason OnboardingV2.tsx's own onPersonaOutsideV2 doc comment gives -
    // D6.) Leaving legacyInitialType alone here is what lets the legacy arm's own session branch
    // (Onboarding.jsx :240-262) take over instead.
    const [sessionPersonaMismatch, setSessionPersonaMismatch] = useState(false);

    if (props.rebrand && !props.isArtistReferral && !legacyInitialType && !sessionPersonaMismatch) {
        return (
            <OnboardingV2
                galleryUserTypeValue={User.getValue(User.Gallery)}
                collectorUserTypeValue={User.getValue(User.Collector)}
                jewelryInventoryTypeValue={Inventory.Jewelry}
                onPersonaOutsideV2={setLegacyInitialType}
                onSessionPersonaMismatch={() => setSessionPersonaMismatch(true)}
                isGhost={props.isGhost}
            />
        );
    }

    return (
        <OnboardingMantineRoot>
            <OnboardingPage {...props} initialType={legacyInitialType} />
        </OnboardingMantineRoot>
    );
};

export default {
    ArtistInvite,
    Claim,
    InvoiceConfirmation,
    Onboarding,
    PasswordReset
};
